import React from 'react';
import AppsContainer from '@tenant/core/AppsContainer';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ROUTE_STRING } from 'constants/RouteString';
import AppInstanceTable from './components/List/AppInstanceTable';

const ListAppInstance = () => {
  return (
    <AppsContainer
      fullView
      title={
        <Breadcrumbs aria-label='breadcrumb'>
          <Typography color='text.primary'>Library</Typography>
          <Typography color='text.primary'>
            <Link to={ROUTE_STRING.APP_INSTANCE.LIST}>App Instances</Link>
          </Typography>{' '}
        </Breadcrumbs>
      }
    >
      <Box
        sx={{
          '& .MuiDataGrid-root': {
            borderLeft: 0,
            borderRight: 0,
            borderTop: 0,
            borderRadius: 0,
          },
        }}
      >
        <AppInstanceTable />
      </Box>
    </AppsContainer>
  );
};

export default React.memo(ListAppInstance);
